import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PlaceService {
  private url = environment.api + "api/erp/places";

  constructor(
    private http: HttpClient
  ) { }

  getPlaces() {
    return this.http.get(this.url);
  }

  getActivePlaces() {
    return this.http.get(this.url + "/active");
  }

  getPlaceById(id: number) {
    return this.http.get(this.url + `/${id}`);
  }

  createPlace(data: { name: string }) {
    return this.http.post(this.url, data);
  }

  updatePlace(id: number, data: { name?: string; active?: boolean }) {
    return this.http.put(this.url, { id, ...data });
  }

  deletePlace(id: number) {
    return this.http.delete(this.url + `/${id}`);
  }

}
